export const FETCH_CUSTOM_PAGES = "FETCH_CUSTOM_PAGES";
export const FETCH_CUSTOM_PAGES_PENDING = "FETCH_CUSTOM_PAGES_PENDING";
export const FETCH_CUSTOM_PAGES_FULFILLED = "FETCH_CUSTOM_PAGES_FULFILLED";
export const FETCH_CUSTOM_PAGES_REJECTED = "FETCH_CUSTOM_PAGES_REJECTED";

export const UPDATE_CUSTOM_PAGES = "UPDATE_CUSTOM_PAGES";
export const UPDATE_CUSTOM_PAGES_PENDING = "UPDATE_CUSTOM_PAGES_PENDING";
export const UPDATE_CUSTOM_PAGES_FULFILLED = "UPDATE_CUSTOM_PAGES_FULFILLED";
export const UPDATE_CUSTOM_PAGES_REJECTED = "UPDATE_CUSTOM_PAGES_REJECTED";

const initialState = {
  data: [],
  loading: false,
  error: null,
  lastUpdated: null,
  currentSuitId: null,
};

export default function customPagesReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_CUSTOM_PAGES_PENDING:
      return {
        ...state,
        loading: true,
        error: null,
        currentSuitId: action.suitId || state.currentSuitId,
      };
    case FETCH_CUSTOM_PAGES_FULFILLED:
      return {
        ...state,
        data: action.payload || [],
        loading: false,
        error: null,
        lastUpdated: new Date(),
        currentSuitId: action.suitId || state.currentSuitId,
      };
    case FETCH_CUSTOM_PAGES_REJECTED:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case UPDATE_CUSTOM_PAGES_PENDING:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case UPDATE_CUSTOM_PAGES_FULFILLED:
      return {
        ...state,
        data: action.payload || [],
        loading: false,
        error: null,
        lastUpdated: new Date(),
      };
    case UPDATE_CUSTOM_PAGES_REJECTED:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}

export const fetchCustomPages = (suitId) => {
  return async (dispatch) => {
    dispatch({
      type: FETCH_CUSTOM_PAGES_PENDING,
      suitId,
    });

    try {
      const { getCurrentSuit } = await import("./user");

      if (!suitId) {
        console.error("No suitId provided to fetchCustomPages");
        return dispatch({
          type: FETCH_CUSTOM_PAGES_FULFILLED,
          payload: [],
          suitId,
        });
      }

      const suitPromise = getCurrentSuit(suitId);
      const response = await suitPromise;

      let customPages = [];
      if (
        response &&
        response.value &&
        response.value.body &&
        response.value.body.meta &&
        response.value.body.meta.customPages
      ) {
        customPages = response.value.body.meta.customPages;
      } else {
        console.warn(
          "Could not find customPages in the response structure",
          response
        );
        if (
          response &&
          response.payload &&
          typeof response.payload.then === "function"
        ) {
          const resolvedResponse = await response.payload;
          if (
            resolvedResponse &&
            resolvedResponse.value &&
            resolvedResponse.value.body &&
            resolvedResponse.value.body.meta &&
            resolvedResponse.value.body.meta.customPages
          ) {
            customPages = resolvedResponse.value.body.meta.customPages;
          } else if (
            resolvedResponse &&
            resolvedResponse.body &&
            resolvedResponse.body.meta &&
            resolvedResponse.body.meta.customPages
          ) {
            customPages = resolvedResponse.body.meta.customPages;
          } else {
            console.warn(
              "Could not find customPages in the resolved response either",
              resolvedResponse
            );
          }
        }
      }

      return dispatch({
        type: FETCH_CUSTOM_PAGES_FULFILLED,
        payload: customPages || [],
        suitId,
      });
    } catch (error) {
      console.error("Error in fetchCustomPages:", error);
      return dispatch({
        type: FETCH_CUSTOM_PAGES_REJECTED,
        payload: error,
      });
    }
  };
};

export const updateCustomPages = (suitId, customPages, suitName, apiKey) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_CUSTOM_PAGES_PENDING });

    try {
      if (!suitId) {
        throw new Error("Cannot update suit: No active suit ID provided");
      }

      const { updateSuitOnServer } = await import(
        "../routes/App/NewSettings/custom-pages/api"
      );
      await updateSuitOnServer(suitId, customPages, suitName, apiKey);

      dispatch({
        type: UPDATE_CUSTOM_PAGES_FULFILLED,
        payload: customPages,
      });

      return customPages;
    } catch (error) {
      console.error("Error updating custom pages:", error);
      dispatch({
        type: UPDATE_CUSTOM_PAGES_REJECTED,
        payload: error,
      });
      throw error;
    }
  };
};
